import React, { Fragment } from 'react'
import NFSFilter from './NFSFilter'
import NFSList from './NFSList'
import { observer, inject } from 'mobx-react'

const NFSDashboard = inject('nfsStore')(observer(props => {
  return (
    <Fragment>
      <NFSFilter />
      <NFSList />
    </Fragment>
  )
}))

export default NFSDashboard



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfs/NFSDashboard.js